/* MyRespCo theme.js — AJAX cart, drawer, sticky ATC, all interactions */
'use strict';

const MR = {
  cart: null,

  money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },

  // ── Fetch cart ────────────────────────────────────────
  async getCart() {
    try {
      const r = await fetch('/cart.js');
      this.cart = await r.json();
      this.updateCounters();
      return this.cart;
    } catch(e) { return null; }
  },

  updateCounters() {
    const n = (this.cart && this.cart.item_count) || 0;
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none';
    });
    const mc = document.getElementById('MobCartCount');
    if (mc) { mc.textContent = n; mc.style.display = n > 0 ? '' : 'none'; }
  },

  // ── AJAX add to cart ──────────────────────────────────
  async addItem(variantId, qty = 1) {
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({id: parseInt(variantId), quantity: qty})
      });
      if (!r.ok) return false;
      await this.getCart();
      this.openDrawer();
      return true;
    } catch(e) { return false; }
  },

  // ── Cart Drawer ───────────────────────────────────────
  openDrawer() {
    const d = document.getElementById('CartDrawer');
    const o = document.getElementById('CartDrawerOverlay');
    if (!d) return;
    this.renderDrawer();
    d.classList.add('open'); o.classList.add('open');
    d.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => document.getElementById('CartDrawerClose')?.focus(), 350);
  },

  closeDrawer() {
    const d = document.getElementById('CartDrawer');
    const o = document.getElementById('CartDrawerOverlay');
    d?.classList.remove('open'); o?.classList.remove('open');
    d?.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  },

  renderDrawer() {
    const items = document.getElementById('DrawerItems');
    const footer = document.getElementById('DrawerFooter');
    const count = document.getElementById('DrawerItemCount');
    if (!items || !footer || !this.cart) return;
    const c = this.cart;
    if (count) count.textContent = c.item_count > 0 ? `(${c.item_count})` : '';

    if (!c.item_count) {
      items.innerHTML = `<div style="text-align:center;padding:60px 20px">
        <div style="font-size:3rem;margin-bottom:14px">🛒</div>
        <p style="color:var(--mid);margin-bottom:20px;font-family:var(--fb)">Your cart is empty</p>
        <a href="/collections/all" style="background:var(--t);color:#fff;padding:12px 24px;border-radius:var(--r1);font-weight:700;text-decoration:none;display:inline-block;font-family:var(--fb)">Browse Products →</a>
      </div>`;
      footer.innerHTML = '';
      return;
    }

    items.innerHTML = c.items.map(item => `
      <div style="display:flex;gap:12px;padding:14px 0;border-bottom:1px solid var(--ym);align-items:flex-start">
        <a href="${item.url}" style="flex-shrink:0">
          <img src="${item.image ? item.image.replace('.jpg','_80x80_crop_center.jpg').replace('.webp','_80x80_crop_center.webp').replace('.png','_80x80_crop_center.png') : ''}"
               alt="${item.product_title}" width="64" height="64"
               style="width:64px;height:64px;object-fit:cover;border-radius:var(--r1);border:1px solid var(--ym);display:block"
               onerror="this.style.display='none'">
        </a>
        <div style="flex:1;min-width:0">
          <a href="${item.url}" style="font-weight:700;font-size:.84rem;color:var(--n);text-decoration:none;display:block;line-height:1.35;font-family:var(--fb)">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:.73rem;color:var(--mid);margin-top:2px;font-family:var(--fb)">${item.variant_title}</div>` : ''}
          <div style="display:flex;align-items:center;justify-content:space-between;margin-top:9px">
            <div style="display:flex;align-items:center;border:1px solid var(--ym);border-radius:var(--r1);overflow:hidden">
              <button onclick="MR.changeQty('${item.key}',${item.quantity-1})" style="width:28px;height:28px;border:none;background:var(--y);cursor:pointer;font-size:1rem;font-family:var(--fb);color:var(--n);display:flex;align-items:center;justify-content:center">−</button>
              <span style="width:32px;text-align:center;font-size:.87rem;font-weight:600;font-family:var(--fb);color:var(--n);border-left:1px solid var(--ym);border-right:1px solid var(--ym);height:28px;display:flex;align-items:center;justify-content:center">${item.quantity}</span>
              <button onclick="MR.changeQty('${item.key}',${item.quantity+1})" style="width:28px;height:28px;border:none;background:var(--y);cursor:pointer;font-size:1rem;font-family:var(--fb);color:var(--n);display:flex;align-items:center;justify-content:center">+</button>
            </div>
            <span style="font-weight:800;color:var(--n);font-family:var(--fh);font-size:1rem">${this.money(item.line_price)}</span>
          </div>
        </div>
        <button onclick="MR.changeQty('${item.key}',0)" aria-label="Remove" style="color:var(--mid);background:none;border:none;cursor:pointer;font-size:.82rem;padding:4px;flex-shrink:0;font-family:var(--fb)">✕</button>
      </div>`).join('');

    footer.innerHTML = `
      <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:12px">
        <span style="font-size:.88rem;color:var(--sl);font-family:var(--fb)">Subtotal</span>
        <span style="font-family:var(--fh);font-size:1.2rem;font-weight:800;color:var(--n)">${this.money(c.total_price)}</span>
      </div>
      <p style="font-size:.73rem;color:var(--mid);margin-bottom:13px;font-family:var(--fb)">Shipping & taxes calculated at checkout</p>
      <a href="/cart" style="display:flex;align-items:center;justify-content:center;gap:6px;background:var(--y);color:var(--n);border:2px solid var(--n);padding:12px;border-radius:var(--r1);font-weight:700;text-decoration:none;margin-bottom:9px;font-family:var(--fb);font-size:.88rem">View Full Cart</a>
      <a href="/checkout" style="display:flex;align-items:center;justify-content:center;gap:7px;background:var(--t);color:#fff;padding:15px;border-radius:var(--r1);font-size:.98rem;font-weight:800;text-decoration:none;box-shadow:0 4px 14px rgba(13,115,119,.35);font-family:var(--fb)">🔒 Proceed to Checkout</a>
      <div style="display:flex;justify-content:center;gap:14px;margin-top:10px;flex-wrap:wrap">
        <span style="font-size:.7rem;color:var(--mid);font-family:var(--fb)">🔒 Secure</span>
        <span style="font-size:.7rem;color:var(--mid);font-family:var(--fb)">↩️ 30-day returns</span>
        <span style="font-size:.7rem;color:var(--mid);font-family:var(--fb)">🩺 RT-inspected</span>
      </div>`;
  },

  async changeQty(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      });
      await this.getCart();
      this.renderDrawer();
    } catch(e) {}
  },

  // ── Product form (AJAX with native fallback) ──────────
  initProductForm() {
    const form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = document.getElementById('AddToCart');
      const variantId = document.getElementById('SelectedVariant')?.value;
      const qty = parseInt(document.getElementById('Quantity')?.value || 1);
      if (!variantId || !btn) { form.submit(); return; }
      const orig = btn.innerHTML;
      btn.innerHTML = '✓ Adding…'; btn.style.background = 'var(--grn)'; btn.disabled = true;
      const ok = await this.addItem(variantId, qty);
      if (!ok) { form.submit(); return; }
      setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 2500);
    });
  },

  // ── Product card forms ────────────────────────────────
  initCardForms() {
    document.querySelectorAll('.prod-atc-form').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('button[name="add"]');
        const variantId = form.querySelector('input[name="id"]')?.value;
        if (!variantId) { form.submit(); return; }
        const orig = btn.innerHTML;
        btn.innerHTML = '✓'; btn.style.background = 'var(--grn)'; btn.disabled = true;
        const ok = await this.addItem(variantId, 1);
        if (!ok) { form.submit(); return; }
        setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 2000);
      });
    });
  },

  // ── Sticky ATC ────────────────────────────────────────
  initStickyATC() {
    const bar = document.getElementById('StickyATC');
    const mainBtn = document.getElementById('AddToCart');
    const stickyBtn = document.getElementById('StickyATCBtn');
    if (!bar || !mainBtn) return;
    const obs = new IntersectionObserver(entries => {
      bar.style.transform = entries[0].isIntersecting ? 'translateY(100%)' : 'translateY(0)';
      bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, {threshold: 0.5});
    obs.observe(mainBtn);
    stickyBtn?.addEventListener('click', async () => {
      const vid = stickyBtn.dataset.variant;
      const qty = parseInt(document.getElementById('StickyQty')?.value || 1);
      const orig = stickyBtn.textContent;
      stickyBtn.textContent = '✓ Adding…'; stickyBtn.style.background = 'var(--grn)';
      const ok = await this.addItem(vid, qty);
      if (!ok) document.getElementById('product-form')?.submit();
      setTimeout(() => { stickyBtn.textContent = orig; stickyBtn.style.background = ''; }, 2000);
    });
  },

  // ── Variants ──────────────────────────────────────────
  initVariants() {
    document.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const vid = btn.dataset.variant;
        const price = parseInt(btn.dataset.price || 0);
        const avail = btn.dataset.available !== 'false';
        document.getElementById('SelectedVariant')?.setAttribute('value', vid);
        const sticky = document.getElementById('StickyATCBtn');
        if (sticky) sticky.dataset.variant = vid;
        const prEl = document.getElementById('ProductPrice');
        if (prEl && price > 0) prEl.textContent = this.money(price);
        const atc = document.getElementById('AddToCart');
        if (atc) {
          if (avail) {
            atc.disabled = false; atc.style.opacity = '1';
            atc.style.background = 'var(--t)'; atc.style.cursor = 'pointer';
            atc.innerHTML = `🛒 Add to Cart — ${this.money(price)}`;
          } else {
            atc.disabled = true; atc.style.opacity = '.65';
            atc.style.background = 'var(--mid)'; atc.style.cursor = 'not-allowed';
            atc.innerHTML = 'Currently Sold Out';
          }
        }
        document.querySelectorAll('.variant-btn').forEach(b => {
          const sel = b.dataset.variant === vid;
          b.style.borderColor = sel ? 'var(--t)' : 'var(--ym)';
          b.style.background = sel ? 'var(--tl)' : 'var(--w)';
          b.style.color = sel ? 'var(--t)' : 'var(--sl)';
        });
      });
    });
  },

  // ── Search ────────────────────────────────────────────
  initSearch() {
    const tog = document.getElementById('SearchToggle');
    const drw = document.getElementById('SearchDrawer');
    const cls = document.getElementById('SearchClose');
    const inp = document.getElementById('SearchInput');
    if (!tog || !drw) return;
    const open = () => { drw.style.transform = 'translateY(0)'; tog.setAttribute('aria-expanded','true'); drw.setAttribute('aria-hidden','false'); setTimeout(()=>inp?.focus(),300); };
    const close = () => { drw.style.transform = 'translateY(-100%)'; tog.setAttribute('aria-expanded','false'); };
    tog.addEventListener('click', () => drw.style.transform === 'translateY(0px)' || drw.style.transform === 'translateY(0)' ? close() : open());
    cls?.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); this.closeDrawer(); closeMob(); }});
  },

  // ── FAQ ───────────────────────────────────────────────
  initFAQ() {
    document.querySelectorAll('.faq-item').forEach(item => {
      item.querySelector('.faq-q')?.addEventListener('click', () => {
        const open = item.classList.contains('open');
        document.querySelectorAll('.faq-item.open').forEach(o => {
          o.classList.remove('open');
          const ic = o.querySelector('.faq-icon'); if(ic) ic.textContent = '+';
        });
        if (!open) {
          item.classList.add('open');
          const ic = item.querySelector('.faq-icon'); if(ic) ic.textContent = '×';
        }
      });
    });
  },

  // ── Accordion ─────────────────────────────────────────
  initAccordion() {
    document.querySelectorAll('.acc-item').forEach(item => {
      const trig = item.querySelector('.acc-trigger');
      const cont = item.querySelector('.acc-content');
      trig?.addEventListener('click', () => {
        const isOpen = cont?.classList.contains('open');
        document.querySelectorAll('.acc-content.open').forEach(c => c.classList.remove('open'));
        document.querySelectorAll('.acc-icon').forEach(i => { if(i) i.textContent = '+'; });
        if (!isOpen && cont) { cont.classList.add('open'); const ic = trig.querySelector('.acc-icon'); if(ic) ic.textContent = '−'; }
      });
    });
    // Open first by default
    const first = document.querySelector('.acc-content.open');
    if (!first) { const fc = document.querySelector('.acc-content'); if(fc) fc.classList.add('open'); }
    document.querySelectorAll('.acc-item').forEach((item,i) => {
      const cont = item.querySelector('.acc-content'); const icon = item.querySelector('.acc-icon');
      if (cont?.classList.contains('open') && icon) icon.textContent = '−';
    });
  },

  // ── Scroll animations ─────────────────────────────────
  initAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.obs').forEach(el => el.classList.add('visible')); return;
    }
    const obs = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
    }), {threshold: 0.08, rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('.obs').forEach(el => obs.observe(el));
  },

  // ── Back to top ───────────────────────────────────────
  initBackToTop() {
    const btn = document.getElementById('BackToTop');
    if (!btn) return;
    window.addEventListener('scroll', () => {
      const show = window.scrollY > 600;
      btn.style.opacity = show ? '1' : '0'; btn.style.visibility = show ? 'visible' : 'hidden';
    }, {passive:true});
  },

  // ── Sticky header shadow ──────────────────────────────
  initHeader() {
    const h = document.querySelector('.site-header');
    if (!h) return;
    window.addEventListener('scroll', () => {
      h.style.boxShadow = window.scrollY > 10 ? '0 4px 20px rgba(10,22,40,.14)' : '';
    }, {passive:true});
  },

  // ── INIT ──────────────────────────────────────────────
  init() {
    this.getCart();
    this.initHeader();
    this.initSearch();
    this.initProductForm();
    this.initCardForms();
    this.initStickyATC();
    this.initVariants();
    this.initFAQ();
    this.initAccordion();
    this.initAnimations();
    this.initBackToTop();

    // Cart drawer events
    document.getElementById('CartDrawerOverlay')?.addEventListener('click', () => this.closeDrawer());
    document.getElementById('CartDrawerClose')?.addEventListener('click', () => this.closeDrawer());

    // Mobile nav
    const closeMob = () => { document.querySelector('.mob-nav')?.classList.remove('open'); document.body.style.overflow = ''; document.querySelector('.mob-btn')?.setAttribute('aria-expanded','false'); };
    document.querySelector('.mob-btn')?.addEventListener('click', () => { document.querySelector('.mob-nav')?.classList.add('open'); document.body.style.overflow = 'hidden'; document.querySelector('.mob-btn')?.setAttribute('aria-expanded','true'); });
    document.querySelector('.mob-close')?.addEventListener('click', closeMob);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeMob(); this.closeDrawer(); } });

    // Sort auto-submit
    document.getElementById('SortSelect')?.addEventListener('change', function() {
      const url = new URL(window.location.href); url.searchParams.set('sort_by', this.value); window.location.href = url.toString();
    });
  }
};

document.addEventListener('DOMContentLoaded', () => MR.init());
